import {
  Component,
  Input,
  model,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MultiItemComponent } from './multi-item/multi-item.component';

@Component({
    selector: 'c-multi-selector',
    templateUrl: './multi-selector.component.html',
    styleUrl: './multi-selector.component.css',
    standalone: false
})
export class MultiSelectorComponent {
  option = model<any>();

  getData(data: any, index: number) {
    const i = this.items.findIndex((i) => i.index == index);
    if (data) {
      if (i === -1) {
        this.items.push({ index, data });
      } else {
        this.items[i].data = data;
      }
    } else if (this.items[i]) {
      this.items[i].data = undefined;
    }
    const d = this.items.map((d) => d.data).filter((d) => d != undefined);
    this.option.set(d);

    this.allSelected = d.length == this.options.length;
    this.partialSelected = d.length > 0 && d.length !== this.options.length;
  }

  /** @description Las opciones a elegir */
  @Input() options!: any;
  /** @description Las sub opciones a elegir, solo se pasa la propiedad de la lista */
  @Input() subOpt!: string;
  /** @description la propiedad del item a mostrar */
  @Input() itemProperty!: string;
  /** @description la propiedad del sub item a mostrar */
  @Input() subItemProperty!: string;
  /** @description la propiedad del item para mostrar descripciones */
  @Input() itemDescriptionProp!: string;
  /** @description la propiedad del sub item para mostrar descripciones */
  @Input() subDescriptionProp!: string;
  /** @description el identificador universal de los items (id) */
  @Input() identificadorI!: string;
  /** @description el identificador universal de los sub items (id) */
  @Input() identificadorS!: string;

  @Input() selectAll = false;
  allSelected = false;
  partialSelected = false;

  @Input() lateral = false;

  //* @description Podemos elegir que el primer element del html sea un checkbox o un titulo */
  @Input() titulo = false;

  /** @description Podemos elegir en seleccionar solo el padre, sin necesidad de incluir a los hijos */
  @Input() parentOnly = false;

  items: { index: number; data: any[] | undefined }[] = [];

  @ViewChildren(MultiItemComponent) subItems!: QueryList<MultiItemComponent>;
  ngAfterViewInit() {
    const items = [...this.option()];
    this.subItems.forEach((item) => {
      const i = item.data[this.identificadorI]
        ? item.data[this.identificadorI]
        : item.data;
      const initData = this.returnData(i, items);
      item.initData(initData);
    });
  }

  returnData(i: any, items: any) {
    const j = items.find(
      (j: any) => (j[this.identificadorI] ? j[this.identificadorI] : j) == i
    );
    return j;
  }

  checkAll() {
    const newState = !this.allSelected; // si todos → false, si parcial/ninguno → true

    this.subItems.forEach((s) => {
      s.check = newState;
      s.selectedItem(newState);
    });
  }
}
